export default {
  approval: {
    search: {
      businessNo: '业务编码',
    },
    table: {
      processType: '审批流程类型',
      businessNo: '业务编码',
      approvaResultName: '状态名',
      approvaResult: '状态',
      businessId: '审批数据id',
      gmtCreate: '创建时间',
    },
    message: {
      chooseOne: '请选择一条数据进行操作',
      choose: '请选择待审批的数据进行操作',
    },
  },
};
